/**
 * //////////////////////////////////////////////////
 * REDUCKSメインファイル
 * --------------------------
 *
 * セレクタ、オペレーション、サガ、リデューサを束ねるメインファイル。
 * Reducksの他のコンポーネント（users）と結合するために、主にducks/index.jsファイルにエクスポートされます。
 * ///////////////////////////////////////////////////
 */

import * as watchersSagas from './watchersSagas';

export const managerRequestWatcherSagas = Object.values(watchersSagas);
export {default as managerRequestSelectors} from "./selectors";
export {default as managerRequestOperations} from "./operations";
export {default as managerRequestTypes} from "./types";
export {default as managerRequestForms} from "./forms"

export {managerRequestState, default as managerRequestReducer} from './reducers';
